/** Imports */
import SimpleCrypto from 'simple-crypto-js';

/** Initialization */
const backendUrl = process.env.API_ADDR;
const flomllr_token = process.env.TOKEN;
const crypt = new SimpleCrypto(flomllr_token);

/** Internal functions */
async function backend(endpoint, body) {
  try {
	  const response = await fetch(backendUrl + endpoint, {
	    mode: 'cors',
	    method: 'post',
	    headers: {
	      'Content-type': 'application/json',
	    },
	    body: JSON.stringify({ flomllr_token, ...body }),
	  });
	  const responseJSON = await response.json();
	  console.dlog(responseJSON);
	  return responseJSON;
  } catch(e) {
	console.log(e);
  }
}

async function shopify(endpoint) {
  const response = await fetch(endpoint);
  return await response.json();
}

async function getValidProductSet(shop, cart, data) {
  // Get array of all products in the cart
  let products_in_cart = [];
  cart.items.forEach(item => {
    products_in_cart.push(item.product_id);
  });

  let validProducts = new Set();
  // Get array of all valid producs
  await Promise.all(
    data.entitled_collection_ids.map(async collection_id => {
      const response = await backend('/store/getcollection', {
        shop,
        collection: collection_id,
        products: products_in_cart,
      });
      if (!response.error) {
        response.collections.forEach(collect => {
          if (products_in_cart.includes(collect.product_id)) {
            validProducts.add(collect.product_id);
          }
        });
      }
    }),
  );
  console.dlog('Valid products', validProducts);
  return validProducts;
}

function checkRestrictions(data, discount) {
  // RESTRICTIONS APPLY - CALCULATED AT CHECKOUT
  if (
    data.usage_limit ||
    data.customer_selection !== 'all' ||
    data.once_per_customer
  ) {
    discount.restriction = '(Code validity verified at checkout)';
  }

  if (
    data.prerequisite_quantity_range && // CHECK MIN ITEM QUANTITY
    discount.eligibleItems &&
    discount.eligibleItems <
      data.prerequisite_quantity_range.greater_than_or_equal_to
  ) {
    console.dlog('Checking eligible items', discount);
    discount.value =
      'Minimum purchase of ' +
      data.prerequisite_quantity_range.greater_than_or_equal_to +
      ' eligible items';
  }
  return discount;
}

/** Exported functions */
export async function saveDiscounts(shop) {
  // Check if discounts are already saved
  let dcodesCrypt = sessionStorage.getItem('dcodes');
  if (dcodesCrypt) {
    return dcodesCrypt;
  }
  // Get discounts from backend and save them
  const { priceRules, error } = await backend('/store/discounts', {
    shop,
  });
  if (!priceRules || error) {
    error('Error getting discount codes');
    return;
  }
  sessionStorage.setItem('dcodes', priceRules);
  return priceRules;
}

export function getCustomSubtotal(customSubtotal) {
  try {
    let subtotalElement = document.querySelector(customSubtotal);
    if (subtotalElement) {
      const currency =
        subtotalElement.nodeType !== Node.TEXT_NODE
          ? subtotalElement.innerText || subtotalElement.textContent
          : subtotalElement.innerHTML;

      const spaceBetween = currency.indexOf(' ') !== -1;
      if (spaceBetween)
        sessionStorage.setItem('dcCurrencySpace', 'true');

      const cur_re = /\D*(\d+|\d.*?\d)(?:\D+(\d{2}))?\D*$/;
      const parts = cur_re.exec(currency);
      const number = parseFloat(
        parts[1].replace(/\D/, '') +
          '.' +
          (parts[2] ? parts[2] : '00'),
      );
      console.dlog('Parts', parts);
      console.dlog('Custom subtotal:', number);
      return number;
    }
  } catch (e) {
    console.error(e);
  }
}
window.getCustomSubtotal = getCustomSubtotal;

export async function saveCartAndCurrency(customSubtotal, shop) {
  const cart = await shopify('/cart.js');

  // Workaround for custom cart plugins
  if (customSubtotal) {
    const subtotal = getCustomSubtotal(customSubtotal);
    if (subtotal) cart.total_price = subtotal * 100;
  }

  const customCart = JSON.parse(localStorage.getItem('boldvq'));
  if (customCart) {
    console.dlog('Detected custom cart by BOLD');
    // Getting prices for items in bold cart
    const { result: customCartWithPrices, error } = await backend(
      '/store/prices',
      {
        shop,
        products: Object.values(customCart),
      },
    );
    if (error) {
      console.dlog(error);
    } else {
      cart.items = [];
      cart.item_count = 0;
      customCartWithPrices.forEach(item => {
        cart.items.push(item);
        cart.item_count += item.quantity;
      });
    }
  }

  const cartString = JSON.stringify(cart);
  const oldCart = sessionStorage.getItem('cart');
  if (oldCart === cartString) return false;
  console.dlog('Cart changed');
  // Cart was updated
  sessionStorage.setItem('cart', cartString);
  let currency = cart.currency;
  switch (currency) {
    case 'EUR':
      currency = '€';
      break;
    case 'USD':
      currency = '$';
      break;
    case 'CAD':
      currency = '$';
      break;
    case 'AUD':
      currency = '$';
      break;
    case 'SGD':
      currency = '$';
      break;
    case 'GBP':
      currency = '£';
      break;
    case 'BRL':
      currency = 'R$';
      break;
    default:
  }
  if (sessionStorage.getItem('dcCurrencySpace')) {
    currency += '&nbsp;';
  }
  sessionStorage.setItem('currency', currency);
  return cart;
}

export async function observeHiddenDiscount(handleDiscount) {
  const hiddenInput = document.querySelector(
    'input[name="discount"]',
  );
  let formElement = hiddenInput
    ? hiddenInput.parentElement
    : undefined;
  formElement = formElement
    ? formElement
    : document.querySelector('form[action="/cart"]');
  if (formElement) {
    let mutationObserver = new MutationObserver(async () => {
      const hiddenDiscount = formElement.querySelector(
        'input[name="discount"]',
      );
      if (hiddenDiscount && hiddenDiscount.value !== '') {
        let currentDiscount = sessionStorage.getItem(
          'currentDiscount',
        );
        currentDiscount = currentDiscount
          ? JSON.parse(currentDiscount)
          : undefined;
        let validating =
          sessionStorage.getItem('dcValidating') ||
          document.querySelector('#dcodeWizardScript');

        console.dlog(
          'Values of validating, currentDiscount and hiddenDiscount',
          validating,
          currentDiscount,
          hiddenDiscount,
        );
        if (
          !validating &&
          (!currentDiscount ||
            currentDiscount.title.toLowerCase() !==
              hiddenDiscount.value.toLowerCase())
        ) {
          console.dlog(
            'Handling discount',
            validating,
            currentDiscount,
            hiddenDiscount.value,
          );
          mutationObserver.disconnect();
          handleDiscount(
            hiddenDiscount.value,
            undefined,
            true,
            !!document.querySelector('#dcodeWizardScript'), // Update settings when wizard is active
            null,
            'DISCOUNT OBSERVER',
          );
        }
      }
    });
    // Starts listening for changes in the root HTML element of the page.
    mutationObserver.observe(formElement, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  }
}

export async function getExistingDiscount() {
  // Check if a shopify discount was applied
  const cookieDiscount = getCookie('discount_code');
  console.dlog('Found discount cookie:', cookieDiscount);
  let currentDiscount;
  if (cookieDiscount && cookieDiscount !== 'EXAMPLE') {
    currentDiscount = { title: cookieDiscount };
  } else {
    currentDiscount = sessionStorage.getItem('currentDiscount');
    currentDiscount = currentDiscount
      ? JSON.parse(currentDiscount)
      : undefined;
  }

  const inputfield = document.querySelector('input[name="discount"]');
  const activeDiscount = inputfield ? inputfield.value : undefined;
  if (
    currentDiscount &&
    activeDiscount &&
    currentDiscount.title !== activeDiscount
  ) {
    console.dlog('Active discount does not equal current discount');
    return { title: activeDiscount, update: true };
  } else if (!currentDiscount) {
    let automaticDiscount = localStorage.getItem('ad_last_applied');
    automaticDiscount = automaticDiscount
      ? JSON.parse(automaticDiscount)
      : undefined;
    if (
      automaticDiscount &&
      automaticDiscount.data &&
      automaticDiscount.data.data
    ) {
      automaticDiscount = automaticDiscount.data.data.code;
      console.dlog(
        'Automatic discount detected: ',
        automaticDiscount,
      );
    }
    currentDiscount = automaticDiscount
      ? { title: automaticDiscount, update: true }
      : undefined;
  }
  return currentDiscount;
}

export async function checkDiscount(shop, discountcode) {
  const savedData = localStorage.getItem(discountcode + '-dcdata');
  if (savedData) {
    return { title: discountcode, codeData: JSON.parse(savedData) };
  }

  // Data not saved yet
  let dcodesCrypt = sessionStorage.getItem('dcodes');
  if (!dcodesCrypt) {
    dcodesCrypt = await saveDiscounts(shop);
  }
  if (dcodesCrypt === 'overflow') {
    const { error, result: codeData } = await backend(
      '/store/validatecode',
      {
        discountcode,
        shop,
      },
    );
    if (!codeData) return { error: 'Could not get discount data' };
    const { title } = codeData;
    return { error, title, codeData };
  } else {
    const dcodesString = crypt.decrypt(dcodesCrypt);
    const dcodes = JSON.parse(dcodesString);
    console.dlog('dcodes', dcodes);
    const codeData = dcodes.find(
      e =>
        e.title.trim().toLowerCase() ===
        discountcode.trim().toLowerCase(),
    );
    if (codeData) {
      // Save discount for even faster application later
      sessionStorage.setItem(
        codeData.title.toLowerCase() + '-dcdata',
        JSON.stringify(codeData),
      );
      if (
        navigator.userAgent.indexOf('MSIE') !== -1 ||
        navigator.appVersion.indexOf('Trident/') > 0
      ) {
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('discountVerifed', true, false, window, 0);
        window.dispatchEvent(evt);
      } else {
        dispatchEvent(
          new CustomEvent('discountVerified', {
            title: codeData.title,
            codeData,
          }),
        );
      }
      return { title: codeData.title, codeData };
    } else {
      let partiallyCorrect = dcodes.find(e =>
        e.title
          .toLowerCase()
          .includes(discountcode.trim().toLowerCase()),
      );
      if (partiallyCorrect) {
        console.dlog('Discount is partially corrent');
        const { error, result: codeData } = await backend(
          '/store/validatecode',
          {
            discountcode,
            shop,
          },
        );
        if (!codeData)
          return { error: 'Could not get discount data' };
        const { title } = codeData;
        return { error, title, codeData };
      }
      return { error: 'Discountcode invalid' };
    }
  }
}

export async function timeValid(data) {
  // check if code is between start and end date
  const today = new Date();
  const startdate = new Date(data.starts_at);
  const enddate = new Date(data.ends_at);

  const notyet = startdate > today;
  const notanymore = startdate < enddate && today >= enddate;
  return !(notyet || notanymore);
}

export async function calculateDiscountValue(shop, data) {
  let discount = {};
  discount.value = 'Value calculated at checkout';
  let cart = JSON.parse(sessionStorage.getItem('cart'));

  // CALCULATE VALUE
  if (
    data.prerequisite_subtotal_range && // CHECK MIN PURCHASE AMOUNT
    cart &&
    cart.total_price / 100 <
      data.prerequisite_subtotal_range.greater_than_or_equal_to
  ) {
    discount.value =
      'Minimum purchase amount ' +
      sessionStorage.getItem('currency') +
      parseFloat(
        data.prerequisite_subtotal_range.greater_than_or_equal_to,
      ).toFixed(2);
  } else {
    // DISCOUNTCODE STILL VALID AND APPLIABLE
    discount.eligibleItems = 0;
    // SHIPPING DISCOUNT
    if (data.target_type === 'shipping_line') {
      if (data.value === -100) discount.value = 'Free shipping';
      // FREE SHIPPING
      else discount.value = 'Discounted shipping'; // DISCOUNTED SHIPPING
      discount.eligibleItems = cart.item_count;
    }
    // PERCENTAGE DISCOUNT
    else if (
      data.target_type === 'line_item' &&
      data.value_type === 'percentage'
    ) {
      const {
        prerequisite_to_entitlement_quantity_ratio,
        prerequisite_product_ids,
        entitled_product_ids,
        prerequisite_collection_ids,
        entitled_collection_ids,
      } = data;

      let { entitled_quantity, prerequisite_quantity } =
        prerequisite_to_entitlement_quantity_ratio || {};
      let prerequisite_items = 0;

      // CHECK IF TYPE 'BUY 1 GET 1'
      if (prerequisite_product_ids.length > 0) {
        cart.items.forEach(item => {
          if (
            data.prerequisite_product_ids.includes(item.product_id)
          ) {
            prerequisite_items += item.quantity;
          }
        });
      } else if (prerequisite_collection_ids.length > 0) {
        const valid_products = await getValidProductSet(
          shop,
          cart,
          data,
        );
        cart.items.forEach(item => {
          if (valid_products.has(item.product_id)) {
            valid_products.delete(item.product_id);
            prerequisite_items += item.quantity;
          }
        });
      }
      // IF BUY 1 GET ONE -> CHECK IF ENOUGH PREREQUISITE ITEMS
      if (
        prerequisite_quantity &&
        prerequisite_items < prerequisite_quantity
      ) {
        discount.value = 'Missing prerequisite products';
        discount.eligibleItems = 0;
      } else {
        if (entitled_product_ids.length > 0) {
          // DISCOUNT ONLY VALID FOR SOME ITEMS
          discount.value = 0;

          // If BUY1GET1, then max eligibleItems can get discount code
          let eligibleItemArr = [];
          let eligibleItemCount = 0;
          cart.items.forEach(item => {
            // Check for each item if it's valid for a discount
            if (entitled_product_ids.includes(item.product_id)) {
              console.dlog(item.product_id, 'is an entitled product');
              eligibleItemArr.push(item);
              eligibleItemCount += item.quantity;
            }
          });
          if (eligibleItemArr.length === 0) {
            discount.value = 'No eligible product in cart';
          } else {
            if (entitled_quantity) {
              console.dlog('Buy1Get2');
              let real_entitled_quantity = Math.min(
                entitled_quantity,
                eligibleItemCount - prerequisite_quantity,
              );
              while (real_entitled_quantity > 0) {
                const maxItem = eligibleItemArr.reduce(
                  (prev, current) =>
                    prev.price > current.price ? prev : current,
                );
                eligibleItemArr.splice(
                  cart.items.indexOf(maxItem),
                  1,
                );
                discount.value +=
                  (maxItem.price / 100) *
                  maxItem.quantity *
                  (parseFloat(data.value) / 100);
                discount.eligibleItems += maxItem.quantity;
                real_entitled_quantity -= maxItem.quantity;
                // If more value was added than eligible, remove the additional value
                if (real_entitled_quantity < 0) {
                  discount.value +=
                    real_entitled_quantity *
                    (maxItem.price / 100) *
                    (parseFloat(data.value) / 100);
                  discount.eligibleItems += real_entitled_quantity;
                }
              }
              if (!discount.eligibleItems) {
                discount.value =
                  'Not enough eligible products in cart';
              }
            } else {
              eligibleItemArr.forEach(item => {
                discount.value +=
                  (item.price / 100) *
                  item.quantity *
                  (parseFloat(data.value) / 100);
                discount.eligibleItems += item.quantity;
              });
            }
          }
        } else if (entitled_collection_ids.length > 0) {
          // DISCOUNT ONLY VALID FOR SOME COLLECTIONS
          discount.value = 0;
          const valid_products = await getValidProductSet(
            shop,
            cart,
            data,
          );
          console.dlog('Valid products...', valid_products);

          // If BUY1GET1, then max eligibleItems can get discount code
          let eligibleItemArr = [];
          let eligibleItemCount = 0;
          console.dlog('Cart...', cart);
          cart.items.forEach(item => {
            console.dlog('Checkint item...', item);
            // Check for each item if it's valid for a discount
            if (valid_products.has(item.product_id)) {
              console.dlog('Pushing item...', item);
              eligibleItemArr.push(item);
              eligibleItemCount += item.quantity;
            }
          });
          if (eligibleItemArr.length === 0) {
            discount.value = 'No eligible product in cart';
          } else {
            if (entitled_quantity) {
              console.dlog('Buy1Get2');
              let real_entitled_quantity = Math.min(
                entitled_quantity,
                eligibleItemCount - prerequisite_quantity,
              );
              while (real_entitled_quantity > 0) {
                const maxItem = eligibleItemArr.reduce(
                  (prev, current) =>
                    prev.price > current.price ? prev : current,
                );
                eligibleItemArr.splice(
                  cart.items.indexOf(maxItem),
                  1,
                );
                discount.value +=
                  (maxItem.price / 100) *
                  maxItem.quantity *
                  (parseFloat(data.value) / 100);
                discount.eligibleItems += maxItem.quantity;
                real_entitled_quantity -= maxItem.quantity;
                // If more value was added than eligible, remove the additional value
                if (real_entitled_quantity < 0) {
                  discount.value +=
                    real_entitled_quantity *
                    (maxItem.price / 100) *
                    (parseFloat(data.value) / 100);
                  discount.eligibleItems += real_entitled_quantity;
                }
              }
              if (!discount.eligibleItems) {
                discount.value =
                  'Not enough eligible products in cart';
              }
            } else {
              console.dlog('Eligible item array', eligibleItemArr);
              eligibleItemArr.forEach(item => {
                discount.value +=
                  (item.price / 100) *
                  item.quantity *
                  (parseFloat(data.value) / 100);
                discount.eligibleItems += item.quantity;
              });
            }
          }
        } else {
          // VALID FOR WHOLE CART
          let cart_raw = JSON.parse(sessionStorage.getItem('cart'));
          if (cart_raw) {
            let cart_subtotal = cart_raw.total_price / 100;
            discount.value =
              (parseFloat(data.value) / 100) * cart_subtotal;
            discount.eligibleItems = cart.item_count;
          }
        }
      }
    }

    // FIXED DISCOUNT
    else if (data.value_type === 'fixed_amount') {
      if (data.entitled_product_ids.length > 0) {
        // FOR SPECIFIC PRODUCTS
        discount.value = 0;
        cart.items.forEach(item => {
          // Check for each item if it's valid for a discount
          if (data.entitled_product_ids.includes(item.product_id)) {
            if (data.allocation_method === 'across') {
              // IF ONCE FOR THE ORDER
              discount.value = data.value;
              discount.eligibleItems += item.quantity;
            } else if (data.allocation_method === 'each') {
              // IF FOR EACH ELIGIBLE PRODUCT
              discount.value +=
                item.quantity * parseFloat(data.value);
              discount.eligibleItems += item.quantity;
            }
          }
        });
        if (discount.value === 0)
          discount.value = 'No eligible product in cart';
      } else if (data.entitled_collection_ids.length > 0) {
        // FOR SPECIFIC COLLECTIONS
        discount.value = 0;
        const validProducts = await getValidProductSet(
          shop,
          cart,
          data,
        );
        console.dlog(
          'Valid product Array',
          Array.from(validProducts),
        );
        console.dlog('Cart:', cart);

        // calculate discount value
        cart.items.forEach(item => {
          console.dlog('Checking item: ', item);
          // Check for each item if it's valid for a discount
          if (validProducts.has(item.product_id)) {
            console.dlog('Valid product found:', item);
            if (data.allocation_method === 'across') {
              // IF ONCE FOR THE ORDER
              // Discount can only be as much as all eligible items together
              discount.value -= (item.price / 100) * item.quantity;
              discount.eligibleItems += item.quantity;
              console.dlog(
                'New item quantity',
                discount.eligibleItems,
              );
              if (discount.value < data.value) {
                discount.value = data.value;
                return true;
              }
            } else if (data.allocation_method === 'each') {
              // IF FOR EACH ELIGIBLE PRODUCT
              discount.value +=
                item.quantity *
                Math.max(
                  parseFloat(data.value),
                  (-1 * item.price) / 100,
                );
              discount.eligibleItems += item.quantity;
            }
          }
        });
        if (discount.value === 0)
          discount.value = 'No eligible product in cart';
        discount = checkRestrictions(data, discount);
        return discount;
      } else {
        // FOR WHOLE CART
        discount.value = data.value;
        discount.eligibleItems = cart.item_count;
      }
    }
    discount = checkRestrictions(data, discount);
  }
  return discount;
}

/**
 * settings: {
 *		plan,
 *		labels,
 *		style,
 *		appActive,
 *		calcActive,
 * 		stamp
 * }
 */
export async function getSettings(shop, stamp) {
  // If the wizard script is detected, return the wizard settings
  if (document.querySelector('#dcodeWizardScript')) {
    const wizardSettings = localStorage.getItem('dcodeSetupSettings');
    if (wizardSettings) return JSON.parse(wizardSettings);
  }
  let settings = localStorage.getItem('dcSettings') || '{}';
  settings = JSON.parse(settings);
  console.dlog(
    'dcode - Scripttag:',
    stamp,
    'Settings:',
    settings.stamp,
  );
  if (!settings.stamp || settings.stamp !== stamp) {
    console.dlog('docde - Refetch settings');
    const { settings: s } = await backend('/store/settings', {
      shop,
    });
    settings = s;
    localStorage.setItem('dcSettings', JSON.stringify(settings));
  }
  console.dlog('dcode - Settings: ', settings);
  return settings;
}

/** Cookie functions */

function decodeURIComponentSafe(s) {
  try {
    if (!s) {
      return s;
    }
    return decodeURIComponent(
      s.replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25'),
    );
  } catch (e) {
    console.log(e);
    return '';
  }
}

export function getCookie(cname) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponentSafe(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
window.getCookie = getCookie;

export function setCookie(cname, cvalue) {
  const d = new Date();
  d.setTime(d.getTime() + 100 * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}
window.setCookie = setCookie;

export function loadShopifyDiscountFrame(discountcode) {
  removeShopifyDiscountFrame();
  console.dlog('Adding shopify discount frame');
  const frame = document.createElement('img');
  frame.src = window.location.origin + '/discount/' + discountcode;
  frame.id = 'dcHiddenDiscountFrame';
  frame.addEventListener('load', removeShopifyDiscountFrame);
  document
    .querySelector('body')
    .insertAdjacentElement('beforeend', frame);
}

function removeShopifyDiscountFrame() {
  console.dlog('Removing shopify discount frames');
  document
    .querySelectorAll('#dcHiddenDiscountFrame')
    .forEach(e => e.remove());
}

export function logDiscountValidation(shop, whoami, discount, valid) {
  console.log('dc_val');
  backend('/store/discountlog', {
    host: window.location.host,
    shop,
    whoami,
    discount,
    valid,
  });
}
